// Marketplace logos - Using colored text badges
// Since original zarooriretail.com images return 404

export const marketplaceLogos = [
  { name: "AJIO LUXE", color: "bg-orange-600" },
  { name: "Ajio", color: "bg-orange-500" },
  { name: "Aza Fashion", color: "bg-amber-600" },
  { name: "Big Basket", color: "bg-green-600" },
  { name: "Blinkit", color: "bg-yellow-500" },
  { name: "FirstCry", color: "bg-cyan-500" },
  { name: "Foxy", color: "bg-pink-500" },
  { name: "HealthMug", color: "bg-emerald-500" },
  { name: "Hopscotch", color: "bg-pink-400" },
  { name: "Jaypore", color: "bg-amber-500" },
  { name: "Kalki Fashion", color: "bg-rose-600" },
  { name: "Lazada", color: "bg-blue-500" },
  { name: "Mirraw Luxe", color: "bg-red-500" },
  { name: "Mirraw", color: "bg-red-400" },
  { name: "M-NOW", color: "bg-pink-600" },
  { name: "Myntra Luxe", color: "bg-pink-700" },
  { name: "Myntra", color: "bg-pink-500" },
  { name: "Noon", color: "bg-yellow-400" },
  { name: "Nykaa Fashion", color: "bg-pink-600" },
  { name: "Nykaa", color: "bg-pink-500" },
  { name: "Pernia's", color: "bg-rose-500" },
  { name: "Purplle", color: "bg-purple-500" },
  { name: "Smytten", color: "bg-teal-500" },
  { name: "Tata CliQ", color: "bg-blue-600" },
  { name: "Zepto", color: "bg-violet-500" },
  { name: "Swiggy", color: "bg-orange-500" },
];

export const ecommerceMarketplaces = [
  { name: "MYNTRA", logo: "/logos/myntra-fashion-marketplace-logo.webp" },
  { name: "NYKAA BEAUTY", logo: "/logos/nykaa-beauty-marketplace-logo.webp" },
  { name: "AJIO", logo: "/logos/ajio-fashion-marketplace-logo.webp" },
  { name: "TATA CLIQ", logo: "/logos/tata-cliq-marketplace-logo.webp" },
  { name: "PERNIA'S POP UP SHOP", logo: "/logos/pernia white logo.png" },
  { name: "TIRA BEAUTY", logo: "/logos/tira-reliance-beauty-marketplace-logo.webp" },
  { name: "PURPLLE", logo: "/logos/purplle-beauty-marketplace-logo.webp" },
  { name: "FIRSTCRY", logo: "/logos/firstcry-kids-marketplace-logo.webp" },
  { name: "TATA 1MG", logo: "/logos/tata-1mg-health-marketplace-logo.webp" },
  { name: "THE LOOM", logo: "/logos/the-loom-premium-fashion-marketplace-logo.png" },
  { name: "NOON", logo: null },
  { name: "MIRRAW LUXURY", logo: "/logos/mirraw-luxe-fashion-marketplace-logo.webp" },
  { name: "PEPPERFRY", logo: "/logos/pepperfry-furniture-marketplace-logo.webp" },
  { name: "BIGBASKET", logo: "/logos/bigbasket-grocery-marketplace-logo.webp" },
  { name: "JIOMART", logo: "/logos/jiomart-retail-marketplace-logo.png" },
  { name: "AMAZON", logo: null },
  { name: "FLIPKART", logo: null },
  { name: "NAMSHI", logo: null },
  { name: "MEESHO", logo: null },
  { name: "AZA FASHION", logo: null },
  { name: "SMYTTEN", logo: null },
  { name: "KALKI FASHION", logo: null },
  { name: "ZALANDO", logo: null },
  { name: "LAZADA", logo: null }
];

export const quickCommerceMarketplaces = [
  { name: "BLINKIT", logo: "/logos/blinkit-quick-commerce-logo.webp" },
  { name: "ZEPTO", logo: "/logos/zepto-quick-commerce-marketplace-logo.webp" },
  { name: "SWIGGY INSTAMART", logo: "/logos/swiggy-instamart-quick-commerce-logo.webp" },
  { name: "BIG BASKET", logo: "/logos/bigbasket-grocery-marketplace-logo.webp" },
  { name: "PINCODE", logo: null },
  { name: "M-NOW", logo: null }
];

export const workingProcess = [
  {
    step: "01",
    title: "Brand-First Strategy",
    description: "We tailor every marketplace solution around your brand's unique identity and goals."
  },
  {
    step: "02",
    title: "Marketplace Expertise",
    description: "We specialize in onboarding and scaling brands on premium platforms like Myntra, Nykaa, and Ajio."
  },
  {
    step: "03",
    title: "Data-Driven Decisions",
    description: "Our actions are backed by insights to maximize visibility, conversion, and growth."
  },
  {
    step: "04",
    title: "Full-Spectrum Support",
    description: "From listing to logistics, we manage the complete journey for effortless retail success."
  },
  {
    step: "05",
    title: "Scalable Modules",
    description: "Choose from ABR, ABT, or ULTIMATE plans to suit your brand's current stage and future vision."
  }
];

export const faqData = [
  {
    question: "How can Zaroori Retail help my brand?",
    answer: "We assist in onboarding your brand to top marketplaces like Myntra, Nykaa, Ajio & more. Our team handles everything from listing to strategy.",
    features: ["Marketplace onboarding", "Brand strategy", "Listing & cataloging", "Compliance handling", "Growth planning", "End-to-end support"]
  },
  {
    question: "What are the services included?",
    answer: "We offer ABR, ABT & ULTIMATE modules tailored for different brand needs. From product upload to marketplace marketing, we've got it covered.",
    features: ["Listing & cataloging", "Account management", "Inventory sync", "Marketplace ads", "Business reporting", "Returns & support"]
  },
  {
    question: "Which platforms do you work with?",
    answer: "We partner with top premium marketplaces where your brand can shine and grow.",
    features: ["Myntra", "Nykaa", "Ajio", "Tata Cliq", "Aza Fashion", "Pernia's Pop-Up"]
  },
  {
    question: "How long does onboarding take?",
    answer: "Onboarding can take 10-21 days based on the platform and your brand readiness. We fast-track the process wherever possible.",
    features: ["Quick documentation", "Brand approval", "Listing formats", "Pricing setup", "Inventory planning", "Go-live coordination"]
  },
  {
    question: "What if I don't have a seller account yet?",
    answer: "No worries! We guide you step-by-step to create and verify your seller account.",
    features: ["Seller ID creation", "Brand documents", "GST/Bank setup", "Platform TnC", "Support during approval", "Smooth onboarding"]
  },
  {
    question: "How do I get in touch for custom support?",
    answer: "You can reach us via WhatsApp, email, or our contact form. We respond within 24 hours!",
    features: ["WhatsApp chat", "Email support", "Website contact form", "Callback option", "Monday–Saturday", "10 AM – 7 PM"]
  }
];

// Using placeholder images for gallery and reviews
export const galleryImages = [
  "https://picsum.photos/seed/zr1/300/300",
  "https://picsum.photos/seed/zr2/300/300",
  "https://picsum.photos/seed/zr3/300/300",
  "https://picsum.photos/seed/zr4/300/300",
  "https://picsum.photos/seed/zr5/300/300",
  "https://picsum.photos/seed/zr6/300/300",
  "https://picsum.photos/seed/zr7/300/300",
  "https://picsum.photos/seed/zr8/300/300",
  "https://picsum.photos/seed/zr9/300/300",
  "https://picsum.photos/seed/zr10/300/300",
  "https://picsum.photos/seed/zr11/300/300",
  "https://picsum.photos/seed/zr12/300/300",
];

// Review images - using placeholder since original URLs are 404
export const reviewImages = [
  "https://picsum.photos/seed/review1/300/400",
  "https://picsum.photos/seed/review2/300/400",
  "https://picsum.photos/seed/review3/300/400",
  "https://picsum.photos/seed/review4/300/400",
  "https://picsum.photos/seed/review5/300/400",
  "https://picsum.photos/seed/review6/300/400",
  "https://picsum.photos/seed/review7/300/400",
  "https://picsum.photos/seed/review8/300/400",
];

export const categories = [
  "Beauty & Cosmetics",
  "Clothing",
  "Footwear",
  "Food",
  "Accessories",
  "Jewellery",
  "Home Decor",
  "Home Furnishing",
  "Other"
];
